<script setup lang="ts">
/**
 * UiCard — секция кабинета (inbox-118).
 *
 * Slots:
 *   header  — опциональный header (если не передан, рендерим title + subtitle)
 *   default — основной контент
 *   footer  — опциональный footer (actions, save-row и т.п.)
 *
 * CSS портом из docs/mockups/dashboard-v1.html + settings-profile.html
 * (.sec-card + .settings-card).
 *
 * Usage:
 *   <UiCard title="Личные данные" subtitle="Имя и аватар видны коллегам">
 *     <div class="field">…</div>
 *     <template #footer>
 *       <UiButton>Сохранить</UiButton>
 *     </template>
 *   </UiCard>
 */

interface Props {
  title?: string;
  subtitle?: string;
}

withDefaults(defineProps<Props>(), {
  title: '',
  subtitle: '',
});
</script>

<template>
  <section class="sec-card">
    <header v-if="$slots.header || title || subtitle" class="card-head">
      <slot name="header">
        <h3 v-if="title">{{ title }}</h3>
        <div v-if="subtitle" class="sub">{{ subtitle }}</div>
      </slot>
    </header>
    <div class="card-body"><slot /></div>
    <footer v-if="$slots.footer" class="card-foot">
      <slot name="footer" />
    </footer>
  </section>
</template>

<style scoped>
.sec-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 16px;
}

.card-head {
  margin-bottom: 20px;
}

.card-head h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px;
  color: var(--fg);
}

.card-head .sub {
  font-size: 13px;
  color: var(--fg-muted);
}

.card-foot {
  margin-top: 16px;
}
</style>
